import { Award, ShieldCheck, BadgeDollarSign, Zap } from "lucide-react";

const MECHANIC_IMG = "/inspector-harrier.png";

const icons = [Award, ShieldCheck, BadgeDollarSign, Zap];

export const WhyUs = ({ t }) => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-neutral-50 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="order-2 lg:order-1 lg:col-span-5">
            <div className="relative overflow-hidden border border-neutral-200">
              <img
                src={MECHANIC_IMG}
                alt="CNG AutoCare inspector performing a leak test in full PPE"
                className="h-full w-full object-cover"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2 lg:col-span-7">
            <div className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-green-600">
              {t.why.label}
            </div>
            <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-neutral-950 sm:text-4xl lg:text-5xl">
              {t.why.title}
            </h2>

            <div className="mt-10 grid grid-cols-1 gap-0 border border-neutral-200 sm:grid-cols-2">
              {t.why.items.map((item, i) => {
                const Icon = icons[i];
                const borderClass = [
                  "sm:border-r sm:border-b",
                  "sm:border-b",
                  "sm:border-r",
                  "",
                ][i];
                return (
                  <div
                    key={i}
                    data-testid={`why-item-${i}`}
                    className={`group relative border-neutral-200 p-7 transition-colors duration-200 hover:bg-white ${borderClass} ${
                      i < t.why.items.length - 1 ? "border-b sm:border-b-0" : ""
                    }`}
                  >
                    <div className="flex h-10 w-10 items-center justify-center bg-neutral-950 text-white transition-colors duration-200 group-hover:bg-green-600">
                      <Icon size={18} />
                    </div>
                    <h3 className="mt-5 font-display text-lg font-bold tracking-tight text-neutral-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-neutral-600">
                      {item.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
